import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updateTitle, updateMetaTags, setCanonicalUrl } from '../utils/seoUtils';
import { APP_METADATA, ROUTES } from '../config/constants';

/**
 * Custom hook for managing SEO metadata
 * @param {Object} seoData - SEO data for the current page
 */
export const useSEO = (seoData = {}) => {
  const location = useLocation();
  const siteUrl = process.env.REACT_APP_SITE_URL || window.location.origin;

  useEffect(() => {
    const {
      title,
      description = APP_METADATA.description,
      keywords = APP_METADATA.keywords,
      image,
    } = seoData;

    // Update title
    updateTitle(title, APP_METADATA.title);

    // Update meta tags
    updateMetaTags({
      description,
      keywords,
      ogTitle: title || APP_METADATA.title,
      ogDescription: description,
      ogImage: image || `${siteUrl}/logo512.png`,
      ogUrl: `${siteUrl}${location.pathname}`,
      twitterTitle: title || APP_METADATA.title,
      twitterDescription: description,
      twitterImage: image || `${siteUrl}/logo512.png`,
    });

    // Set canonical URL
    setCanonicalUrl(`${siteUrl}${location.pathname}`);

    // Cleanup function to reset title when component unmounts
    return () => {
      updateTitle('', APP_METADATA.title);
    };
  }, [location.pathname, seoData, siteUrl]);
};

